import { render, staticRenderFns } from "./MinutesCard.vue?vue&type=template&id=82c08a58&"
import script from "./MinutesCard.vue?vue&type=script&lang=js&"
export * from "./MinutesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports